import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d857df8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bolder","color":"red"} }, "*Chú ý: kích thước khung ảnh chính(360 x 232 pixel), kích thước hình ảnh thành phần(50 x 50 pixel)")
], -1))
const _hoisted_2 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_3 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_4 = { enctype: "multipart/form-data" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "p-field p-col-12 p-md-12"
}
const _hoisted_7 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_8 = { id: "loading" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang tải hình lên máy chủ ...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_panel = _resolveComponent("panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Button, {
            class: "p-button-outlined",
            label: "Đính kèm tập tin",
            onclick: "document.getElementById('myFile').click()",
            icon: "pi pi-paperclip",
            style: {"margin-right":"5vw"}
          }),
          _createVNode(_component_Button, {
            label: "Đăng hình",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.upload())),
            icon: "pi pi-plus-circle",
            style: {"margin-right":"5vw"}
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _createElementVNode("input", {
              id: "myFile",
              type: "file",
              style: {"display":"none"},
              accept: ".jpeg,.png,.jpg",
              name: "files",
              multiple: "multiple",
              onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.fileChange($event.target.files))),
              disabled: $setup.loadingBar
            }, null, 40, _hoisted_5)
          ])
        ]),
        ($setup.listFileName.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_DataTable, {
                value: $setup.listFileName,
                showGridlines: "",
                responsiveLayout: "scroll",
                style: {"font-size":"13px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "nameFile",
                    header: "Tập tin"
                  }),
                  _createVNode(_component_Column, {
                    field: "",
                    header: "",
                    style: {"width":"20px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        class: "p-button-danger",
                        label: "Xóa",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.deleteFile(slotProps.data.nameFile)),
                        style: {"font-size":"13px"}
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Dialog, {
        header: "Tải hình",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ], 64))
}